<template>
  <div class="service">

    <div :class="{'pho':caa}" class="contact">
      <div>
        <a class="link"
           href="http://wpa.qq.com/msgrd?v=3&amp;uin=574039568&amp;site=qq&amp;menu=yes">
          <i class="QQ"></i></a>
        <p style="font-size:0.8rem">QQ咨询</p>
      </div>

    </div>

    <div @mousemove="caa=true" @mouseout="caa=false" class="phoneContact ">

      <div>
        <i class="phone"></i>
        <p style="font-size:0.8rem">电话咨询</p>
      </div>
      <span style="color:#fff">
        0755-2308-0620
      </span>

      <!-- <p></p> -->
    </div>

  </div>
</template>
<script>
export default {
    data(){
        return{
            caa:false
        }
    },

}
</script>
<style lang="scss" scoped>
.pho{
    position: relative;
    right: -70%;
}
// qq联系人
.QQ {
  background: url(../../assets/imges/fx.png) no-repeat;
  display: block;
  width: 30px;
  height: 25px;
  margin: 0px auto;
  text-align: center;
  background-position: 4px 5px;
}
// 电话联系
.phone {
  background: url(../../assets/imges/fx.png) no-repeat;
  display: block;
  width: 30px;
  height: 27px;
  margin: 0px auto;
  text-align: center;
  background-position: 0 -21px;
}

.service {
  position: fixed;
  top: 30rem;
  right: 0;
  z-index: 3;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  //   QQ图样式
  .contact:hover {
    width: 70px;
  }
  .contact {
    background-color: #6ebf64;
    padding: 5px;
    width: 60px;
    display: flex;
    justify-content: flex-end;
    border-bottom: 0.1rem solid #fff;
    text-align: right;
    div{
        float: right;
    }
    
    
    p {
      color: #fff;
      text-align: center;
    }
  }
  // 电话联系人
  .phoneContact:hover {
    width: 200px;
    div {
      display: inline-block;
    }

    span {
      display: inline-block;
      font-size: 0.8rem;
    }
  }
  .phoneContact {
    background-color: #6ebf64;
    padding: 5px;
    display: flex;
    text-align: right;
    align-items: center;
    transform: width 5s;
    border-bottom: 0.1rem solid #fff;
    div {
      flex: 1.5;
    }
    span {
      flex: 2.5;
      border-left: 0.1rem solid #fff;
      text-align: left;
    }
    p {
      color: #fff;
      text-align: center;
    }
    span {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GlobalComponents/service.vue